export default {
    throttle: require('lodash/throttle')
}